import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ThemeToggleComponent } from '../../shared/components/theme-toggle/theme-toggle.component';

@Component({
  selector: 'app-public-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, ThemeToggleComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <main class="min-h-screen w-full relative flex flex-col bg-transparent">
      <!-- Background Blobs (Hidden on Mobile) -->
      <!-- Decorative colour blobs are light-mode only: the dark theme is a flat matte canvas -->
      <div class="fixed inset-0 overflow-hidden pointer-events-none hidden md:block dark:md:hidden">
        <div class="fixed inset-0 overflow-hidden pointer-events-none">
          <div
            class="absolute w-[600px] h-[600px] rounded-full blur-[130px] transition-all duration-1000
             bg-[#9810FA]/20 dark:bg-purple-500/10"
            style="top: 10%; left: 5%;"
          ></div>
          <div
            class="absolute w-[500px] h-[500px] rounded-full blur-[110px] transition-all duration-1000
             bg-[#10F2FA]/10 dark:bg-slate-500/5"
            style="bottom: 10%; right: 10%;"
          ></div>
          <div
            class="absolute w-[450px] h-[450px] rounded-full blur-[120px] transition-all duration-1000
            bg-[#102FFA]/20 dark:bg-purple-800/10"
            style="top: 40%; right: 5%;"
          ></div>
        </div>
      </div>

      <!-- Global Theme Toggle (Hidden on Mobile) -->
      <div class="absolute top-6 right-6 z-50 hidden md:block">
        <app-theme-toggle
          [variant]="'button'"
          [buttonClass]="'border border-gray-200 dark:border-line'"
        ></app-theme-toggle>
      </div>

      <!-- Router content -->
      <section class="flex-1 flex justify-center items-center p-0 md:p-6">
        <div class="w-full h-full">
          <router-outlet></router-outlet>
        </div>
      </section>
    </main>
  `,
})
export class PublicLayoutComponent {}
